var map = {
	"./scene1.png": "e85e",
	"./scene2.png": "4e2e",
	"./scene3.png": "4b29",
	"./scene4.png": "20d3",
	"./scene5.png": "0db4",
	"./scene6.png": "5e59"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "353c";